import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoMessageTypeEnum } from '@websky/graphql';
import Notification from '@websky/core/src/Notification';
import css from './RetrieveHint.css';
const RetrieveHint = () => {
    const { t } = useTranslation('RetrieveBooking');
    return (React.createElement(Notification, { type: "context", className: css.notification, textClassName: css.notification__text, iconClassName: css.notification__icon, status: InfoMessageTypeEnum.Warning, infoMessage: {
            text: t('Booking not found. Please, check the information entered or use your e-ticket number for identification'),
            type: InfoMessageTypeEnum.Warning,
            code: 'warning'
        } }));
};
export default RetrieveHint;
